import '../styles/dropdown.less';
import $ from 'jquery';
import { render } from 'mustache';

import * as common from '../../../shared/modules/common';
import { hasFocusinEvent } from '../../../shared/modules/support';
import { addMutationHandlers } from '../../../shared/modules/domchange';

import { init as initInput } from '../../Input/js/input';

import dropdownView from './dropdownView';
import dropdownSearch from './dropdownSearch';

function Dropdown(markup) {
    var $markup = $(markup),
        container,
        mutationObserver;

    function getOptionTexts(options) {
        return common.map.call(options, function (option) {
            return common.textContent(option);
        });
    }

    function markOptionSelected(option) {
        // This is the standard way of marking option as selected
        option.selected = true;
        // We decided to show the selected option in markup.
        // Because of that we need to set the selected attribute
        // But in IE selected attribute is read only and reflects the
        // defaultSelected property
        option.defaultSelected = true;
        option.setAttribute('selected', '');
    }

    function unmarkOptionsSelected(options) {
        options = options.length ? options : [options];
        common.forEach.call(options, function (option) {
            // This is the standard way of marking option as unseleced
            option.selected = false;
            // We decided to show the selected option in markup.
            // Because of that we need to set the selected attribute
            // But in IE selected attribute is read only and reflects the
            // defaultSelected property
            option.defaultSelected = false;
            option.removeAttribute('selected');
        });
    }

    function isOptionSelected(option) {
        return option.selected;
    }

    function getAllOptions() {
        return markup.querySelectorAll('option');
    }

    function getSelectedOptions() {
        return common.filter.call(getAllOptions(), isOptionSelected);
    }

    function getNotSelectedOptions() {
        return common.filter.call(getAllOptions(), function (option) {
            return !isOptionSelected(option);
        });
    }

    function getOptionByText(text) {
        var options = markup.querySelectorAll('option'),
            option,
            i;

        for (i = 0; i < options.length; i++) {
            if (common.textContent(options[i]) === text) {
                option = options[i];
                break;
            }
        }

        return option;
    }

    function getSearchField() {
        return container.querySelector('.uwr-input');
    }

    function openOverlay() {
        var searchField = getSearchField();

        common.addClass(container, 'uwr-dropdown-container-opened');

        if (searchField) {
            searchField.focus();
        }
    }

    function closeOverlay() {
        var searchField = getSearchField();

        common.removeClass(container, 'uwr-dropdown-container-opened');

        if (searchField) {
            searchField.value = '';
            renderOptionList();
        }
    }

    function isOverlayOpened() {
        return common.hasClass(markup.parentNode, 'uwr-dropdown-container-opened');
    }

    function containerClickHandler(event) {
        var $content = $markup.next(),
            $topLabel = $content.next().find('.uwr-dropdown-top-label');

        if (getSearchField() === common.getEventTarget(event, true)) {
            return;
        }

        if (isMultiple()) {
            $topLabel.height($markup.parent().innerHeight() - $topLabel.innerHeight() + $topLabel.height());
        }

        if (isOverlayOpened()) {
            closeOverlay();
        } else {
            openOverlay();
        }
    }

    function selectItemHandler(event) {
        var target = common.getEventTarget(event, true),
            selectedText = common.textContent(common.getEventTarget(event, true)),
            selectedOption,
            sameSelection;

        if (!common.hasClass(target, 'uwr-dropdown-item')) {
            return;
        }

        selectedOption = getOptionByText(selectedText);
        sameSelection = isOptionSelected(selectedOption);

        if (!sameSelection) {
            updateModel({
                unselectOption: !isMultiple() && markup.querySelectorAll('option'),
                selectOption: selectedOption
            });
            updateView();
            markup.setAttribute('data-uwr-dropdown-change', '');
            common.dispatchEvent('change', markup);
        }
    }

    function multipleSelectedClickHandler(event) {
        var target = common.getEventTarget(event, true),
            selectedText = common.textContent(target);

        if (!common.hasClass(target, 'uwr-dropdown-multi-selected')) {
            return;
        }

        updateModel({ unselectOption: getOptionByText(selectedText) });
        updateView();
        closeOverlay();

        common.stopPropagation(event);
        common.preventDefault(event);
        markup.setAttribute('data-uwr-dropdown-change', '');
        common.dispatchEvent('change', markup);
    }

    function onBlurHandler() {
        // IE8 no event.relatedTarget workaround :(
        setTimeout(function () {
            if (container.contains(document.activeElement)) {
                return;
            }

            closeOverlay();
        }, 0);
    }

    function updateModel(mutation) {
        mutationObserver.byPass(function () {
            if (mutation && mutation.unselectOption) {
                unmarkOptionsSelected(mutation.unselectOption);
            }
            if (mutation && mutation.selectOption) {
                markOptionSelected(mutation.selectOption);
            }
            common.forEach.call(getAllOptions(), function (option) {
                if (isOptionSelected(option)) {
                    markOptionSelected(option);
                } else {
                    unmarkOptionsSelected(option);
                }
            });
        });
    }

    function updateView() {
        var selectValue = container.querySelector('.uwr-dropdown-selected-value'),
            selectedOptionTexts = getOptionTexts(getSelectedOptions()),
            bottomLabel = container.querySelector('.uwr-dropdown-bottom-label'),
            bottomLabelAfterSelect = container.querySelector('.uwr-dropdown-bottom-label-after-select');

        if (isMultiple()) {
            selectValue.innerHTML = render(dropdownView.multiSelected, {
                optionElements: selectedOptionTexts
            });
        } else {
            common.textContent(selectValue, selectedOptionTexts[0]);
        }

        renderOptionList();

        if (selectedOptionTexts.length) {
            common.addClass(bottomLabel, 'uwr-dropdown-hidden-element');
            common.removeClass(bottomLabelAfterSelect, 'uwr-dropdown-hidden-element');
        } else {
            common.removeClass(bottomLabel, 'uwr-dropdown-hidden-element');
            common.addClass(bottomLabelAfterSelect, 'uwr-dropdown-hidden-element');
        }
    }

    function rebuildView() {
        cleanup();
        init();
    }

    function setSize(value) {
        var optionList = container.querySelector('.uwr-dropdown-option-list'),
            elementNumber = Math.min(value, optionList.children.length);
        /* .uwr-dropdown-item height: 48px */
        if (value) {
            optionList.style.height = elementNumber * 48 + 'px';
        } else {
            optionList.style.height = '';
        }
    }

    function modelChangeHandler() {
        if (!markup.hasAttribute('data-uwr-dropdown-change')) {
            updateModel();
            updateView();
        } else {
            markup.removeAttribute('data-uwr-dropdown-change');
        }
    }

    function isMultiple() {
        return markup.hasAttribute('multiple');
    }

    function renderOptionList() {
        var searchField = getSearchField(),
            optionTexts = getOptionTexts(!isMultiple() ? getAllOptions() : getNotSelectedOptions()),
            filteredOptionTexts = searchField ? dropdownSearch(optionTexts, searchField.value) : optionTexts,
            optionsElementsHtml = render(dropdownView.options, {
                optionElements: filteredOptionTexts
            }),
            messageHtml;

        if (searchField) {
            messageHtml = render(dropdownView.message, {
                noMatch: filteredOptionTexts.length === 0,
                searchPattern: searchField.value
            });
            container.querySelector('.uwr-dropdown-message').innerHTML = messageHtml;
        }

        container.querySelector('.uwr-dropdown-option-list').innerHTML = optionsElementsHtml;

        setSize(common.intData(markup, 'option-list-max-size', 0));
    }

    function setLabel(value) {
        var label = markup.parentElement.querySelector('.uwr-dropdown-bottom-label-after-select');
        label.innerText = value;
    };

    function setEmptyLabel(value) {
        var bottomLabel = markup.parentElement.querySelector('.uwr-dropdown-bottom-label'),
            topLabel = markup.parentElement.querySelector('.uwr-dropdown-top-label');

        bottomLabel.innerText = value;
        topLabel.innerText = value;
    }

    function init() {
        if (!common.shouldBeInitialized(markup)) {
            return;
        }

        var labelBeforeSelect = common.data(markup, 'label-before-select'),
            labelAfterSelect = common.data(markup, 'label-after-select'),
            searchEnabled = typeof common.data(markup, 'search-enabled') !== 'undefined',
            $contentView = $(render(dropdownView.content, {
                labelBeforeSelect: labelBeforeSelect,
                labelAfterSelect: labelAfterSelect,
                searchEnabled: searchEnabled
            })),
            searchField,
            multiSelectValue;

        $markup.wrap(dropdownView.container);
        container = markup.parentNode;
        // markup.selectedIndex;
        $contentView.insertAfter($markup);
        searchField = getSearchField();
        multiSelectValue = container.querySelector('.uwr-dropdown-selected-value');

        renderOptionList();

        if (isMultiple()) {
            $markup.parent().addClass('uwr-dropdown-multi');
        }

        if (searchField) {
            initInput(searchField);
            common.addEventListener('input', searchField, renderOptionList);
            common.addEventListener('blur', searchField, onBlurHandler);
        }

        if (multiSelectValue) {
            common.addEventListener(['click', 'dblclick'], multiSelectValue, multipleSelectedClickHandler);
        }

        $markup.parent().on('click', containerClickHandler);
        $markup.parent().on('blur', onBlurHandler);
        // Use focusin for focus bubbling to the container node in IE
        if (hasFocusinEvent) {
            common.addEventListener('focusin', container, function (event) {
                var target = common.getEventTarget(event, true);
                if (!target.hasAttribute('tabindex') && target !== getSearchField()) {
                    common.stopPropagation(event);
                    common.preventDefault(event);
                    container.focus();
                }
            });
        }

        updateView();
        common.addEventListener('click', container.querySelector('.uwr-dropdown-option-list'), selectItemHandler);
        $markup.on('change', modelChangeHandler); // required to support jquery 'change' event triggering

        mutationObserver = addMutationHandlers(markup, {
            node: {
                'data-option-list-max-size': function (mutation) {
                    setSize(common.intData(mutation.target, 'option-list-max-size', 0));
                },
                'data-label-after-select': function (mutation) {
                    setLabel(common.data(mutation.target, 'label-after-select'));
                },
                'data-label-before-select': function (mutation) {
                    setEmptyLabel(common.data(mutation.target, 'label-before-select'));
                },
                'multiple': rebuildView,
                'data-search-enabled': rebuildView
            },
            subtree: {
                'selected': updateView,
                childList: updateView,
                characterData: updateView
            }
        });

        common.markInitialized(markup);

        return this;
    }

    function cleanup() {
        if (mutationObserver) {
            mutationObserver.disconnect();
        }
        common.unwrapMarkup(markup, container);
        common.removeEventListener('change', markup, modelChangeHandler);
        markup.removeAttribute('data-uwr-dropdown-change');
        container = undefined;
        mutationObserver = undefined;

        common.unmarkInitialized(markup);

        return this;
    }

    return {
        init: init,
        cleanup: cleanup
    };
}

/**
 * Initialize the selected Dropdown(s)
 * Supported use cases:
 *   - init();
 *   - init(callback);
 *   - init(selector);
 *   - init(selector, callback);
 * @param selector CSS selector string that returns the elements that need to be initialized.
 *   Optional: If not passed in, then all elements marked with "uwr-dropdown" CSS class will be processed.
 * @param callback The function to run after initialization (optional).
 */
export var init = common.initWidget.bind(null, '.uwr-dropdown', Dropdown);



//////////////////
// WEBPACK FOOTER
// ./widgets/Dropdown/js/dropdown.js
// module id = 31
// module chunks = main